/* eslint-disable import/no-duplicates */
import { format, getTime, formatDistanceToNow } from 'date-fns';
import { fr, enUS } from 'date-fns/locale';
import i18n from '../locales/i18n';

// ----------------------------------------------------------------------

type InputValue = Date | string | number | null;

/**
 * Returns the date-fns locale matching the current i18n language.
 */
export function getDateLocale() {
  const lang = i18n.language || 'fr';
  if (lang.startsWith('fr')) return fr;
  return enUS;
}

export function fDate(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm, { locale: getDateLocale() }) : '';
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm, { locale: getDateLocale() }) : '';
}

export function fTimestamp(date: InputValue) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date: InputValue) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
        locale: getDateLocale(),
      })
    : '';
}
